import {IonContent, IonPage} from '@ionic/react';
import * as React from 'react';
import Header from '../../components/Header/Header';
import Footer from "../../components/Footer/Footer";
import JobHistory from '../../components/FileDownload/JobHistory';
import './History.css';

/**
 * Every export the signed-in user has run, read from the export API's own job
 * records. The page used to read a Firestore `Files` collection that nothing
 * writes any more, so it was empty for everyone.
 */
const History: React.FC = () => (
    <IonPage>
        <Header title="History" />
        <IonContent fullscreen className="page-content">
            <div className="page-body">
                <div className="page-body__meta">
                    <h1 className="page-body__title">Your download history</h1>
                    <span>Every file you have requested, newest first</span>
                </div>
                {/* JobHistory brings its own panel, so it is not wrapped again here. */}
                <JobHistory />
                <Footer/>
            </div>
        </IonContent>
    </IonPage>
);

export default History;
